import { Component, input } from '@angular/core';
import { NotificationBadgeComponent } from '@sb/ui/badge';

@Component({
  selector: 'sb-profile-item',
  imports: [NotificationBadgeComponent],
  template: `<a class="flex w-full px-2" [attr.href]="href()" [attr.target]="!!href() ? '_blank' : undefined">
    <div
      class="flex flex-1 items-center justify-between gap-2 rounded-lg p-3.5 text-lg font-semibold text-default hover:bg-overlay-hover xl:rounded xl:px-2 xl:py-1 xl:text-base xl:font-normal"
    >
      <ng-content>
        <span>
          {{ title() }}
        </span>
      </ng-content>
      @if (notificationCount() > 0) {
        <sb-notification-badge [count]="notificationCount()" [size]="'small'" [truncate]="false" />
      }
    </div>
  </a>`,
})
export class SBProfileItemComponent {
  title = input<string>();
  notificationCount = input<number>();
  href = input<string>();
}
